import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=1bb45d00&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"
import style1 from "./Editor.vue?vue&type=style&index=1&id=1bb45d00&prod&scoped=true&lang=css"
import style2 from "./Editor.vue?vue&type=style&index=2&id=1bb45d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb45d00",
  null
  
)

export default component.exports